import React, { useEffect, useState } from 'react'
import './settings.scss'
import { TbApiApp, TbBrandSpeedtest, TbWifi } from "react-icons/tb";
import { IoMdHelpCircleOutline } from "react-icons/io";
import { useDispatch, useSelector } from 'react-redux';
import { networkSpeed } from '../../../assets/javascript/function-helper';
import { sizeOfJson } from '../../../assets/javascript/find-helpers';
import { clearInstallationForm, clearReworkForm } from '../../../redux/features/user/appDataSlice';

const Settings = ({ setPageHead }) => {
    const dispatch = useDispatch()
    const { internet } = useSelector((state) => state.systemInfo)
    const { user } = useSelector((state) => state.userAuth)
    const { i_form, rework } = useSelector((state) => state.appData)
    const [networkStatus, setNetworkStatus] = useState('Connecting...')

    const clearAppData = () => {

        if (!i_form && !rework) {
            return;
        }

        const ask = window.confirm('Are you ready to Clear App data ?')

        if (ask) {
            dispatch(clearInstallationForm())
            dispatch(clearReworkForm())
        }
    }

    const findNetworkSpeed = async () => {
        const networkSpeedResponse = await networkSpeed()
        if (!internet) {
            setNetworkStatus('No connection')
        } else {
            setNetworkStatus(networkSpeedResponse?.speedStatus)
        }
        return;
    }

    const helpFormNavigate = () => {
        window.open(`https://docs.google.com/forms/d/e/1FAIpQLSfHzaBzc0SLS9BFJ_yGgtQsX290fiZrjymAK0tAIMDFmnSazw/viewform?usp=pp_url&entry.2086004218=${user?.dvc_id}&entry.1229166839=${user?.acc_id}&entry.319667061=${user?.first_name} ${user?.last_name}&entry.1265184055=Installation+App`, '_blank')
    }

    useEffect(() => {
        setPageHead({ title: 'Settings' })

        findNetworkSpeed()
    }, [])

    useEffect(() => {
        findNetworkSpeed()
    }, [internet])

    return (
        <div className="installation-settings-page-div">
            <div className="list-div">
                <h4>Network</h4>
                <div className="list-item-div">
                    <div className="item-div">
                        <div className="name-div">
                            <TbWifi />
                            <div className="text-div">
                                <h4>Internet status</h4>
                            </div>
                        </div>
                        <div className="action-div">
                            <p>{internet ? 'Online' : 'Offline'}</p>
                        </div>
                    </div>
                    <div className="item-div">
                        <div className="name-div">
                            <TbBrandSpeedtest />
                            <div className="text-div">
                                <h4>Speed</h4>
                                {networkStatus === 'Slow' && <p>You network status very low.</p>}
                            </div>
                        </div>
                        <div className="action-div">
                            <p>{networkStatus}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="list-div">
                <h4>System Data</h4>
                <div className="list-item-div">
                    <div className="item-div" onClick={() => clearAppData()}>
                        <div className="name-div">
                            <TbApiApp />
                            <div className="text-div">
                                <h4>App Data</h4>
                                {(!i_form && !rework) ? <p>Your default app data size.</p> : <p>Click to clear your app data.</p>}
                            </div>
                        </div>
                        <div className="action-div">
                            <p>{sizeOfJson({ i_form, rework })}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="list-div">
                <div className="list-item-div">
                    <div className="item-div" onClick={helpFormNavigate}>
                        <div className="name-div">
                            <IoMdHelpCircleOutline />
                            <div className="text-div">
                                <h4>Help center</h4>
                                <p>Submit your feedback, helps us improve software.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

// TbBrandApplePodcast

export default Settings